import { DocumentEditingType } from 'services/api/api-client.types.ts';
import { constantSessionId } from 'helpers/sessionProvider.ts';

export const currentUserIsMagadanEditor = (
  sessionId?: string | null,
  editingType?: DocumentEditingType | null,
) =>
  sessionId === constantSessionId &&
  editingType === DocumentEditingType.Magadan;
